import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Briefcase,
  CalendarDays,
  CheckSquare,
  Users,
  Folder,
  Receipt,
  FileText,
  Bot,
  Settings,
  CircleHelp,
  Search,
  FileDown,
  Share2,
  Gift,
  X,
} from "lucide-react";

import logo from "../../assets/JuridentLogo.png";
import "./sidebar.css";

const mainMenu = [
  {
    title: "Dashboard",
    icon: <LayoutDashboard size={18} />,
    path: "/portal/dashboard",
  },
  {
    title: "Cases",
    icon: <Briefcase size={18} />,
    path: "/portal/allcases",
  },
  {
    title: "Calendar",
    icon: <CalendarDays size={18} />,
    path: "/portal/calendar",
  },
  {
    title: "Tasks & Events",
    icon: <CheckSquare size={18} />,
    path: "/portal/tasksevents",
  },
  {
    title: "Clients",
    icon: <Users size={18} />,
    path: "/portal/myclients",
  },
  {
    title: "Teams",
    icon: <Users size={18} />,
    path: "/portal/teams",
  },
  {
    title: "Documents",
    icon: <Folder size={18} />,
    path: "/portal/myfiles",
  },
  {
    title: "Invoices & Billing",
    icon: <FileText size={18} />,
    path: "/portal/invoices",
  },
  {
    title: "Expenses",
    icon: <Receipt size={18} />,
    path: "/portal/expenses",
  },
  {
    title: "Jurident Assistance",
    icon: <Bot size={18} />,
    path: "/portal/juriassistance",
  },
  {
    title: "Find Cases",
    icon: <Search size={18} />,
    path: "/portal/findCasesOptions",
  },
  {
    title: "Export Cause List",
    icon: <FileDown size={18} />,
    path: "/portal/export-cause-list",
  },
  {
    title: "Shared Cases",
    icon: <Share2 size={18} />,
    path: "/portal/SharedCases",
  },
  {
    title: "Referrals",
    icon: <Gift size={18} />,
    path: "/portal/referrals",
  },
];

const bottomMenu = [
  {
    title: "Settings",
    icon: <Settings size={18} />,
    path: "/portal/account",
  },
  {
    title: "Help & Support",
    icon: <CircleHelp size={18} />,
    path: "/portal/contact-us",
  },
];

// `open` / `onClose` only matter below the desktop breakpoint, where the
// sidebar renders as an off-canvas drawer over the page (see sidebar.css).
export default function Sidebar({ open = false, onClose = () => {} }) {
  return (
    <>
      {/* Dimmed backdrop — drawer mode only; CSS keeps it hidden on desktop. */}
      <div
        className={`crm-sidebar-backdrop ${open ? "open" : ""}`}
        onClick={onClose}
        aria-hidden="true"
      />

      <aside className={`crm-sidebar ${open ? "open" : ""}`}>

  <div className="crm-sidebar-top">

    <div className="crm-logo">
      <img src={logo} alt="Jurident" />

      {/* Drawer close affordance — hidden on desktop. */}
      <button
        type="button"
        className="crm-sidebar-close"
        onClick={onClose}
        aria-label="Close menu"
      >
        <X size={18} />
      </button>
    </div>

    <nav className="crm-nav">
      {mainMenu.map((item) => (
        <NavLink
          key={item.title}
          to={item.path}
          onClick={onClose}
          className={({ isActive }) =>
            isActive ? "crm-link active" : "crm-link"
          }
        >
          {item.icon}
          <span>{item.title}</span>
        </NavLink>
      ))}
    </nav>


  </div>

  <div className="crm-sidebar-bottom">

    <nav className="crm-nav">
      {bottomMenu.map((item) => (
        <NavLink
          key={item.title}
          to={item.path}
          onClick={onClose}
          className={({ isActive }) =>
            isActive ? "crm-link active" : "crm-link"
          }
        >
          {item.icon}
          <span>{item.title}</span>
        </NavLink>
      ))}
    </nav>

  </div>

      </aside>
    </>
  );
}